const statisticsGeneral = {
  en: {
    translation: {
      not_reviewed_checkins: "check-in",
      reviews: "Reviews",
      not_enough_data: "Not enough data yet",
      not_enough_data_cr: "Check-in and reviews",
      not_enough_data_favorites: "Favorites",
      not_enough_data_search: "Views",
      reviews_on: " reviews out of ",
      checkins_done: " check-ins:",
      to_try: "To Try",
      to_remember: "To Remember",
      from_web: "Web",
      from_app: "App",
      watched_your_business: " Foodies have viewed your card:",
      favorite_first_part: "",
      favorite_second_part: " Foodies have added you to their favorites:",
      trend_ci_reviews: "Check-in and reviews performance",
      trend_show_click: "Views and searches performance",
      legend_review: "Completed reviews",
      legend_checkins: "Check-ins completed in your business",
      legend_click: "Full view of your business card details",
      legend_search: "View of your business card among users' search results",
      not_enough_reviews: "Not enough reviews yet",
      reviewed_as: "You have been reviewed as:",
      percentage_weight_questions: "Percentage weight of the questions for: "
    }
  },
  it: {
    translation: {
      not_reviewed_checkins: "Check-in",
      reviews: "Recensioni",
      not_enough_data: "Non ci sono abbastanza dati",
      not_enough_data_cr: "Check-in e recensioni",
      not_enough_data_favorites: "Preferiti",
      not_enough_data_search: "Visualizzazioni",
      reviews_on: " recensioni su ",
      checkins_done: " check-in effettuati:",
      to_try: "Da Provare",
      to_remember: "Da Ricordare",
      from_web: "Da Sito",
      from_app: "Da App",
      watched_your_business: " Foodies hanno visualizzato la tua scheda:",
      favorite_first_part: "Sei tra i favoriti di ",
      favorite_second_part: " Foodies:",
      trend_ci_reviews: "Andamento di check-in e recensioni",
      trend_show_click: "Andamento di visualizzazioni e ricerche",
      legend_review: "Recensioni effettuate",
      legend_checkins: "Check-in effettuati nel tuo locale",
      legend_click: "Visualizzazione completa della scheda di dettaglio",
      legend_search:
        "Visualizzazione della tua scheda attività tra i risultati di ricerca degli utenti",
      not_enough_reviews: "Non ci sono ancora abbastanza recensioni",
      reviewed_as: "Sei stato recensito come:",
      percentage_weight_questions: "Peso in percentuale delle domande per: "
    }
  }
};

export default statisticsGeneral;
